if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.getSubmitLabelElement();

        if (this.variantIdInput && !this.submitButton?.disabled) {
          this.variantIdInput.disabled = false;
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.syncSubmitButtonLabel();
      }

      keepsPpcAtcLabel() {
        return this.submitButton?.dataset.vtPpcKeepAtcLabel === 'true';
      }

      syncSubmitButtonLabel() {
        if (!this.submitButton || !this.submitButtonText) return;

        const label = this.submitButtonText.textContent?.trim();
        if (this.submitButton.disabled || this.submitButton.hasAttribute('disabled')) {
          if (this.keepsPpcAtcLabel()) {
            const ppcLabel = this.submitButton.dataset.atcLabel;
            if (ppcLabel) this.submitButtonText.textContent = ppcLabel;
            return;
          }
          if (!label) {
            this.submitButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
          return;
        }

        if (!label) {
          const customLabel = this.submitButton.dataset.atcLabel;
          this.submitButtonText.textContent = customLabel || window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      getSubmitLabelElement() {
        if (!this.submitButton) return null;

        return (
          this.submitButton.querySelector('[data-vt-ppc-atc-text]') ||
          this.submitButton.querySelector('[data-vt-sticky-atc-label]') ||
          this.submitButton.querySelector('.vt-pdp__atc-text') ||
          this.submitButton.querySelector('.vt-pdp__atc-label') ||
          this.submitButton.querySelector('span:not(.svg-wrapper)')
        );
      }

      setSubmitLoadingState(isLoading) {
        this.submitButtonText = this.getSubmitLabelElement();
        const spinner = this.querySelector('.loading__spinner');

        if (isLoading) {
          this.savedButtonText =
            this.submitButtonText?.textContent?.trim() || window.variantStrings?.addToCart || 'Add to cart';
          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings?.addingToCart || 'Adding to cart...';
          }
          this.submitButton?.setAttribute('aria-busy', 'true');
          spinner?.classList.add('hidden');
          return;
        }

        this.submitButton?.removeAttribute('aria-busy');
        if (!this.error && this.submitButtonText) {
          this.submitButtonText.textContent = this.savedButtonText || window.variantStrings?.addToCart || 'Add to cart';
        }
        spinner?.classList.add('hidden');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.setSubmitLoadingState(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.setSubmitLoadingState(false);

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.submitButtonText = this.getSubmitLabelElement();
        const soldOutEl = this.submitButton?.querySelector('.sold-out-message');

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (this.keepsPpcAtcLabel()) {
            const ppcLabel = this.submitButton.dataset.atcLabel;
            if (ppcLabel && this.submitButtonText) {
              this.submitButtonText.textContent = ppcLabel;
            }
            return;
          }
          if (text) {
            this.submitButton.classList.add('vt-pdp__atc--unavailable');
            if (this.submitButtonText) {
              this.submitButtonText.textContent = text;
              this.submitButtonText.classList.remove('hidden');
            } else if (soldOutEl) {
              soldOutEl.classList.remove('hidden');
            }
          } else if (this.submitButtonText && !this.submitButtonText.textContent?.trim()) {
            this.submitButton.classList.add('vt-pdp__atc--unavailable');
            this.submitButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.classList.remove('vt-pdp__atc--unavailable');
          soldOutEl?.classList.add('hidden');
          const customLabel = this.submitButton.dataset.atcLabel;
          if (this.submitButtonText) {
            this.submitButtonText.textContent = customLabel || window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
